/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * Zone.js and its flags are loaded by the build's "polyfills" option in
 * angular.json — src/zone-flags.ts first, then zone.js, then this file —
 * so the flags are always set before zone.js is evaluated and the unit-test
 * builder can detect zone.js to set up the ZoneJS testing environment.
 */

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
(window as any).global = window;
